import styled, { ThemeProvider, css } from 'styled-components';
import { Spacing12, Spacing16, Spacing20, Spacing32, Spacing8 } from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';
import { ArticleHeaderFromContextProps } from './shared/types';
import SectionName from './components/SectionName';
import Title from './components/Title';
import Teaser from './components/Teaser';
import Image from './components/Image';
import Label from './components/Label';
import Participants from './components/Participants';

// #region Styles
const Wrapper = styled.div`
    margin-bottom: ${Spacing32};

    ${({ theme }) =>
        theme.onDemandLayout &&
        css`
            display: grid;
            grid-template-areas:
                'section'
                'image'
                'tags'
                'title'
                'participants'
                'teaser';

            ${breakpoint.up(sizes.lg)} {
                display: block;
            }
        `};
`;

const StyledSectionName = styled(SectionName)`
    margin-bottom: ${Spacing16};
    grid-area: section;

    ${({ theme }) =>
        theme.onDemandLayout &&
        css`
            display: none;

            ${breakpoint.up(sizes.lg)} {
                display: block;
            }
        `}
`;

const StyledTitle = styled(Title)`
    margin-top: 0;
    margin-bottom: ${Spacing12};
    grid-area: title;

    ${breakpoint.up(sizes.lg)} {
        margin-bottom: ${Spacing20};
    }
`;

const StyledTeaser = styled(Teaser)`
    margin-bottom: ${Spacing16};
    grid-area: teaser;
`;

const StyledImage = styled(Image)`
    grid-area: image;
    margin-bottom: ${Spacing16};
`;

const StyledLabel = styled(Label)`
    grid-area: tags;
    margin-bottom: ${Spacing8};
    margin-right: auto;
`;

const StyledParticipants = styled(Participants)`
    grid-area: participants;
    ${({ theme }) =>
        theme.onDemandLayout &&
        css`
            margin-bottom: ${Spacing8};
        `}
`;

// #endregion Styles

export default function ArticleHeaderFromContext(props: ArticleHeaderFromContextProps) {
    const { image, section, liveEvent, teaser, title, label, participants } = props;

    return (
        <ThemeProvider theme={{ onDemandLayout: !!(liveEvent?.liveEvent.status === 'OnDemand') }}>
            <Wrapper>
                {section && <StyledSectionName sectionInfo={section} />}
                <StyledTitle forwardedAs="h1" title={title} />
                <StyledTeaser teaser={teaser} />
                {participants && participants.length > 0 && <StyledParticipants paticipants={participants} />}
                {label && <StyledLabel label={label} />}
                {image && <StyledImage image={image} liveEvent={liveEvent} />}
            </Wrapper>
        </ThemeProvider>
    );
}
